export const MODULES = {
    // Workspace
    DASHBOARD: 'dashboard',
    PROFILE: 'profile',
    // Productivity
    TASK: 'task',
    ADDITIONAL_TASK: 'additional_task',
    GOALS: 'goals',
    CALENDAR: 'calendar',
    MESSENGER: 'messenger',
    SOP: 'sop',
    NOTICE: 'notice',
    HRMS_NOTICE: 'hrms_notice',
    // Operations
    ORGANIZATION: 'organization',
    HRMS_STAFF: 'hrms_staff',
    HRMS_ORGANIZATION: 'hrms_organization',
    HRMS_SOP: 'hrms_sop',
    HRMS_RECRUITMENT: 'hrms_recruitment',
    HRMS_LEAVE: 'hrms_leave',
    HRMS_PAYROLL: 'hrms_payroll',
    HRMS_ATTENDANCE: 'hrms_attendance',
    HRMS_ANNOUNCEMENT: 'hrms_announcement',
    HRMS_PENALTY: 'hrms_penalty',
    HRMS_TRACKING: 'hrms_tracking',
    LEAVE: 'leave',
    SCHEDULE_OVERVIEW: 'schedule_overview',
    SCHEDULE_BOOK: 'schedule_book',
    SCHEDULE_MY_BOOKINGS: 'schedule_my_bookings',
    SCHEDULE_MANAGE: 'schedule_manage',
    REPORTS_OVERVIEW: 'reports_overview',
    REPORTS_DAILY: 'reports_daily',
    // Finance & Resources
    FINANCE_VENDORS: 'finance_vendors',
    FINANCE_PURCHASES: 'finance_purchases',
    FINANCE_LEDGER: 'finance_ledger',
    FINANCE_REIMBURSEMENTS: 'finance_reimbursements',
    FINANCE_REIMBURSEMENT_SELF: 'finance_reimbursement_self',
    FINANCE_MASTER: 'finance_master',
    ASSETS_LIST: 'assets_list',
    ASSETS_OVERVIEW: 'assets_overview',
    ASSETS_MASTER: 'assets_master',
    ASSETS_ID_MANAGEMENT: 'assets_id_management',
    REQUIREMENTS_LIST: 'requirements_list',
    REQUIREMENTS_MASTER: 'requirements_master',
    REQUIREMENTS_OVERVIEW: 'requirements_overview',
    SUBSCRIPTION_LIST: 'subscription_list',
    SUBSCRIPTION_OVERVIEW: 'subscription_overview',
    SUBSCRIPTION_MASTER: 'subscription_master',
    // Teams & Support
    TECH_SUPPORT: 'tech_support',
    SUPPORT: 'support',
    ROADMAP_OVERVIEW: 'roadmap_overview',
    ROADMAP_GOALS: 'roadmap_goals',
    ROADMAP_MY_GOALS: 'roadmap_my_goals',
    // System
    MASTER_ROLES: 'master_roles',
    MASTER_DEPARTMENTS: 'master_departments',
    MASTER_DESIGNATIONS: 'master_designations',
    MASTER_SHIFTS: 'master_shifts',
    MASTER_HOLIDAYS: 'master_holidays',
    RESTRICTED_ACCESS: 'restricted_access',
    RESTRICTED_LOCK: 'restricted_lock',
    RESTRICTED_HISTORY: 'restricted_history',
    ACCOUNT_ME: 'account_me',
    ACCOUNT_DOCS: 'account_docs',
    ACCOUNT_ATTENDANCE: 'account_attendance',
    ACCOUNT_SALARY: 'account_salary',
    ACCOUNT_LOANS: 'account_loans',
    ACCOUNT_MANAGE: 'account_manage',
    ACCOUNT_PASSWORD: 'account_password',
    ACCOUNT_ASSETS: 'account_assets',
    ACCOUNT_MY_IDS: 'account_my_ids',
};
export const ALL_MODULE_CODES = Object.values(MODULES);
export const MODULE_CATEGORIES = {
    WORKSPACE: 'workspace',
    PRODUCTIVITY: 'productivity',
    OPERATIONS: 'operations',
    FINANCE_RESOURCES: 'finance_resources',
    TEAMS_SUPPORT: 'teams_support',
    SYSTEM: 'system',
};
export const MODULE_CATEGORY = {
    [MODULES.DASHBOARD]: MODULE_CATEGORIES.WORKSPACE,
    [MODULES.PROFILE]: MODULE_CATEGORIES.WORKSPACE,
    [MODULES.TASK]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.ADDITIONAL_TASK]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.GOALS]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.CALENDAR]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.MESSENGER]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.SOP]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.NOTICE]: MODULE_CATEGORIES.PRODUCTIVITY,
    [MODULES.HRMS_NOTICE]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.ORGANIZATION]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_STAFF]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_ORGANIZATION]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_SOP]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_RECRUITMENT]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_LEAVE]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_PAYROLL]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_ATTENDANCE]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_ANNOUNCEMENT]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_PENALTY]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.HRMS_TRACKING]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.LEAVE]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.SCHEDULE_OVERVIEW]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.SCHEDULE_BOOK]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.SCHEDULE_MY_BOOKINGS]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.SCHEDULE_MANAGE]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.REPORTS_OVERVIEW]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.REPORTS_DAILY]: MODULE_CATEGORIES.OPERATIONS,
    [MODULES.FINANCE_VENDORS]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.FINANCE_PURCHASES]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.FINANCE_LEDGER]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.FINANCE_REIMBURSEMENTS]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.FINANCE_REIMBURSEMENT_SELF]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.FINANCE_MASTER]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.ASSETS_LIST]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.ASSETS_OVERVIEW]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.ASSETS_MASTER]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.ASSETS_ID_MANAGEMENT]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.REQUIREMENTS_LIST]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.REQUIREMENTS_MASTER]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.REQUIREMENTS_OVERVIEW]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.SUBSCRIPTION_LIST]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.SUBSCRIPTION_OVERVIEW]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.SUBSCRIPTION_MASTER]: MODULE_CATEGORIES.FINANCE_RESOURCES,
    [MODULES.TECH_SUPPORT]: MODULE_CATEGORIES.TEAMS_SUPPORT,
    [MODULES.SUPPORT]: MODULE_CATEGORIES.TEAMS_SUPPORT,
    [MODULES.ROADMAP_OVERVIEW]: MODULE_CATEGORIES.TEAMS_SUPPORT,
    [MODULES.ROADMAP_GOALS]: MODULE_CATEGORIES.TEAMS_SUPPORT,
    [MODULES.ROADMAP_MY_GOALS]: MODULE_CATEGORIES.TEAMS_SUPPORT,
    [MODULES.MASTER_ROLES]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.MASTER_DEPARTMENTS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.MASTER_DESIGNATIONS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.MASTER_SHIFTS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.MASTER_HOLIDAYS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.RESTRICTED_ACCESS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.RESTRICTED_LOCK]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.RESTRICTED_HISTORY]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_ME]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_DOCS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_ATTENDANCE]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_SALARY]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_LOANS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_MANAGE]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_PASSWORD]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_ASSETS]: MODULE_CATEGORIES.SYSTEM,
    [MODULES.ACCOUNT_MY_IDS]: MODULE_CATEGORIES.SYSTEM,
};
export const MODULE_LABEL = {
    [MODULES.DASHBOARD]: 'Dashboard',
    [MODULES.PROFILE]: 'My Profile',
    [MODULES.TASK]: 'Task',
    [MODULES.ADDITIONAL_TASK]: 'Additional Task',
    [MODULES.GOALS]: 'Goals',
    [MODULES.CALENDAR]: 'Calendar',
    [MODULES.MESSENGER]: 'Messenger',
    [MODULES.SOP]: 'SOP',
    [MODULES.NOTICE]: 'Notice',
    [MODULES.HRMS_NOTICE]: 'Manage Notices',
    [MODULES.ORGANIZATION]: 'Organization',
    [MODULES.HRMS_STAFF]: 'Staff Management',
    [MODULES.HRMS_ORGANIZATION]: 'HRMS · Organization',
    [MODULES.HRMS_SOP]: 'HRMS · Manage SOP',
    [MODULES.HRMS_RECRUITMENT]: 'Recruitment',
    [MODULES.HRMS_LEAVE]: 'Leave Management',
    [MODULES.HRMS_PAYROLL]: 'Payroll',
    [MODULES.HRMS_ATTENDANCE]: 'Attendance',
    [MODULES.HRMS_ANNOUNCEMENT]: 'Announcement',
    [MODULES.HRMS_PENALTY]: 'Penalty Approval',
    [MODULES.HRMS_TRACKING]: 'Tracking',
    [MODULES.LEAVE]: 'Leave',
    [MODULES.SCHEDULE_OVERVIEW]: 'Schedule · Overview',
    [MODULES.SCHEDULE_BOOK]: 'Schedule · Book Slot',
    [MODULES.SCHEDULE_MY_BOOKINGS]: 'Schedule · My Bookings',
    [MODULES.SCHEDULE_MANAGE]: 'Schedule · Manage Slots',
    [MODULES.REPORTS_OVERVIEW]: 'Reports · Overview',
    [MODULES.REPORTS_DAILY]: 'Reports · Daily',
    [MODULES.FINANCE_VENDORS]: 'Finance · Vendors',
    [MODULES.FINANCE_PURCHASES]: 'Finance · Purchases',
    [MODULES.FINANCE_LEDGER]: 'Finance · Ledger',
    [MODULES.FINANCE_REIMBURSEMENTS]: 'Finance · Reimbursements',
    [MODULES.FINANCE_REIMBURSEMENT_SELF]: 'My Reimbursement',
    [MODULES.FINANCE_MASTER]: 'Finance · Master',
    [MODULES.ASSETS_LIST]: 'Assets · List',
    [MODULES.ASSETS_OVERVIEW]: 'Assets · Overview',
    [MODULES.ASSETS_MASTER]: 'Assets · Master',
    [MODULES.ASSETS_ID_MANAGEMENT]: 'Assets · ID Management',
    [MODULES.REQUIREMENTS_LIST]: 'Requirements · List',
    [MODULES.REQUIREMENTS_MASTER]: 'Requirements · Master',
    [MODULES.REQUIREMENTS_OVERVIEW]: 'Requirements · Overview',
    [MODULES.SUBSCRIPTION_LIST]: 'Subscription · List',
    [MODULES.SUBSCRIPTION_OVERVIEW]: 'Subscription · Overview',
    [MODULES.SUBSCRIPTION_MASTER]: 'Subscription · Master',
    [MODULES.TECH_SUPPORT]: 'Tech Support',
    [MODULES.SUPPORT]: 'Support',
    [MODULES.ROADMAP_OVERVIEW]: 'Roadmap · Overview',
    [MODULES.ROADMAP_GOALS]: 'Roadmap · Goals',
    [MODULES.ROADMAP_MY_GOALS]: 'Roadmap · My Goals',
    [MODULES.MASTER_ROLES]: 'Roles & Permissions',
    [MODULES.MASTER_DEPARTMENTS]: 'Departments',
    [MODULES.MASTER_DESIGNATIONS]: 'Designations',
    [MODULES.MASTER_SHIFTS]: 'Shifts',
    [MODULES.MASTER_HOLIDAYS]: 'Holidays',
    [MODULES.RESTRICTED_ACCESS]: 'Access Manager',
    [MODULES.RESTRICTED_LOCK]: 'Lock System',
    [MODULES.RESTRICTED_HISTORY]: 'User History',
    [MODULES.ACCOUNT_ME]: 'My Account',
    [MODULES.ACCOUNT_DOCS]: 'Documentation',
    [MODULES.ACCOUNT_ATTENDANCE]: 'My Attendance',
    [MODULES.ACCOUNT_SALARY]: 'Salary Overview',
    [MODULES.ACCOUNT_LOANS]: 'Loan Overview',
    [MODULES.ACCOUNT_MANAGE]: 'Manage Account',
    [MODULES.ACCOUNT_PASSWORD]: 'Change Password',
    [MODULES.ACCOUNT_ASSETS]: 'My Assets',
    [MODULES.ACCOUNT_MY_IDS]: 'My IDs',
};
//# sourceMappingURL=modules.js.map